module.exports = __webpack_public_path__ + "img/section3Logo3.76b3e8bd.svg";